import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getLoginList = createAsyncThunk(
  "loginList/getLoginList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/login`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const resData = response?.data?.data;

      // Conditionally set Customer values
      if (resData?.vCustomerUniqueCode) {
        sessionStorage.setItem(
          "Customer-vUniqueCode",
          resData.vCustomerUniqueCode
        );
      }
      if (resData?.iCustomerId) {
        sessionStorage.setItem("CustomerId", resData.iCustomerId);
      }

      // Conditionally set Contractor values
      if (resData?.vContractorUniqueCode) {
        sessionStorage.setItem(
          "Contractor-vUniqueCode",
          resData.vContractorUniqueCode
        );
      }
      if (resData?.iContractorId) {
        sessionStorage.setItem("ContractorId", resData.iContractorId);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const loginSlice = createSlice({
  name: "loginList",
  initialState: {
    loading: false,
    loginData: null,
    error: null,
  },
  reducers: {
    ResetLoginState: (state) => {
      state.loading = false;
      state.loginData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLoginList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLoginList.fulfilled, (state, action) => {
        state.loading = false;
        state.loginData = action.payload;
      })
      .addCase(getLoginList.rejected, (state, action) => {
        state.loading = false;
        state.loginData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetLoginState } = loginSlice.actions;
export default loginSlice.reducer;
